import { Flex } from 'onefaceui-react-components';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  50% {
      opacity: .5;
  }
`;

export const Container = styled(Flex)`
  .oneface-table {
    width: 100%;

    .tabulator .tabulator-row .tabulator-cell {
      text-wrap: wrap;

      &[tabulator-field='baseline'],
      &[tabulator-field='planned'],
      &[tabulator-field='projected'],
      &[tabulator-field='actual'] {
        justify-content: center;
      }
    }
  }

  .loading-progress {
    height: 8px;
    display: flex;
    width: 100%;
    background: var(--grey-300);
    border-radius: 2px;
    border: none;

    animation-name: ${pulse};
    animation-duration: 2s;
    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
    animation-iteration-count: infinite;
  }

  .routeMonitorRouteItem {
    .routeMonitorProgressBarContainer {
      width: 100%;
    }

    .routeMonitorRouteStatusIcon {
      width: 18px;
      height: 18px;
      margin: 0;
    }
  }

  .shortcuts-btn {
    height: unset;
  }

  .locations {
    > div {
      min-width: 0;
    }
  }

  .assignments-list {
    min-width: 0;

    .item {
      text-transform: uppercase;
      max-width: 110px;
    }

    .editable {
      cursor: pointer;
      text-decoration: underline;
      color: var(--secondary-400);
    }

    .assign-button {
      background: none;
      border: none;
      padding: 0;
      outline: none;
      height: 20px;
      font-weight: bold;
    }
  }

  .oneface-accordion {
    .accordion-header {
      padding: 0;
    }

    .accordion-body {
      padding: 0 !important;
    }
  }
`;
